import styled from 'styled-components/macro';
import { color, space } from 'styled-system';
import { Box } from 'components/ui';

const Hyperlink = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${color}
  ${space}
`;

const ContractsList = () => (
  <Box>
    <Hyperlink href="https://eulerbeats.gitbook.io/eulerbeats-docs/contracts" color="white">
      Contracts
    </Hyperlink>
  </Box>
)

export default ContractsList;
